import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import CustomPagination from "../pagignation/custompagination";

const ListDynamicTable = ({
  columns,
  columnNames,
  data,
  totalRows,
  pageSize,
  currentPage,
  setCurrentPage,
  onRowClick,
  getData,
  onEditClick,
  onDeleteClick,
  showProceed = true,
  colorConditionColumn = null,
  colorConditionValue = null,
}) => {
  const actionColumns =
    (onEditClick ? 1 : 0) + (onDeleteClick ? 1 : 0) + (showProceed ? 1 : 0);

  const totalColumns = columns.length + actionColumns;

  const isHighlighted = (row) => {
    return (
      colorConditionColumn && row[colorConditionColumn] === colorConditionValue
    );
  };

  const formatValue = (column, value) => {
    if (
      column.toLowerCase().includes("date") &&
      value &&
      moment(value, moment.ISO_8601, true).isValid()
    ) {
      return moment(value).format("DD-MMM-YYYY");
    }

    return value ?? "";
  };

  return (
    <>
      <style>
        {`



/* =========================================================
   CELL CONTENT - MAX 4 LINES
========================================================= */

.dynamic-cell-content {
  display: -webkit-box !important;

  -webkit-box-orient: vertical !important;
  -webkit-line-clamp: 3 !important;

  overflow: hidden !important;

  white-space: normal !important;
  overflow-wrap: anywhere !important;
  word-break: break-word !important;

  text-overflow: ellipsis !important;

  line-height: 1.35 !important;

  max-width: 100% !important;
  width: 100% !important;

  box-sizing: border-box !important;
}


/* Header content */

.dynamic-header-content {
  display: -webkit-box !important;

  -webkit-box-orient: vertical !important;
  -webkit-line-clamp: 4 !important;

  overflow: hidden !important;

  white-space: normal !important;
  overflow-wrap: anywhere !important;
  word-break: break-word !important;

  text-overflow: ellipsis !important;

  line-height: 1.25 !important;

  max-width: 100% !important;
  width: 100% !important;

  box-sizing: border-box !important;
}

    /* =========================================================
       TABLE OUTER WRAPPER
    ========================================================= */

    .dynamic-table-wrapper {
      width: 100%;
      max-width: 100%;
      min-width: 0;

      margin: 12px 0 20px 0;

      background: #ffffff;

      border-radius: 16px;

      border: 1px solid #e1e6ef;

      box-shadow:
        0 6px 24px rgba(0, 68, 145, 0.10);

      overflow: hidden;

      box-sizing: border-box;
    }


    /* =========================================================
       TABLE AREA
    ========================================================= */

    .dynamic-table-scroll {
      width: 100%;
      max-width: 100%;
      min-width: 0;

      overflow-x: hidden;
      overflow-y: visible;

      box-sizing: border-box;
    }


    /* =========================================================
       TABLE

       IMPORTANT:
       table-layout: fixed forces columns to respect
       available screen width.
    ========================================================= */

    .dynamic-data-table {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;

      table-layout: fixed !important;

      margin: 0 !important;

      border-collapse: separate !important;
      border-spacing: 0 !important;

      background: #ffffff;

      box-sizing: border-box;
    }


    /* =========================================================
       HEADER DISPLAY FIX
    ========================================================= */

    .dynamic-data-table thead {
      display: table-header-group !important;

      visibility: visible !important;
      opacity: 1 !important;
    }

    .dynamic-data-table thead tr {
      display: table-row !important;

      visibility: visible !important;
      opacity: 1 !important;
    }

    .dynamic-data-table thead th {
      display: table-cell !important;

      visibility: visible !important;
      opacity: 1 !important;
    }


    /* =========================================================
       HEADER
    ========================================================= */

    .dynamic-table-header {
      background:
        linear-gradient(
          135deg,
          #0d47a1 0%,
          #1565c0 45%,
          #1976d2 100%
        ) !important;

      color: #ffffff !important;

      border: none !important;
    }


    .dynamic-table-header th {
      background:
        linear-gradient(
          135deg,
          #0d47a1 0%,
          #1565c0 45%,
          #1976d2 100%
        ) !important;

      color: #ffffff !important;

      padding: 11px 8px !important;

      font-size: 12px !important;

      font-weight: 700 !important;

      letter-spacing: 0.1px;

      /*
        VERY IMPORTANT:
        Header text can wrap.
      */
      white-space: normal !important;

      overflow-wrap: anywhere;
      word-break: break-word;

      line-height: 1.25;

      text-align: center;

      vertical-align: middle !important;

      border: none !important;

      border-right:
        1px solid rgba(255,255,255,0.15) !important;

      border-bottom:
        2px solid rgba(255,255,255,0.20) !important;

      box-sizing: border-box;

      /*
        Prevent content from forcing column width.
      */
      overflow: hidden;
    }


    /* =========================================================
       BODY ROW
    ========================================================= */

    .dynamic-data-table tbody tr {
      background: #ffffff;

      transition:
        background-color 0.18s ease,
        box-shadow 0.18s ease;
    }


    .dynamic-data-table tbody tr:hover {
      background: #f4f8fd !important;

      box-shadow:
        inset 4px 0 0 #1976d2;
    }


    /* =========================================================
       BODY CELLS

       THIS IS THE MAIN FIX FOR YOUR SCREENSHOT
    ========================================================= */

    .dynamic-data-table tbody td {
      padding: 9px 8px !important;

      font-size: 13px !important;

      color: #263238 !important;

      vertical-align: middle !important;

      border-top: none !important;

      border-left: none !important;

      border-right:
        1px solid #e5e9ef !important;

      border-bottom:
        1px solid #e5e9ef !important;

      /*
        NEVER use nowrap here.
      */
      white-space: normal !important;

      /*
        Normal long text wrapping.
      */
      overflow-wrap: anywhere !important;

      word-break: break-word !important;

      /*
        Long text cannot enlarge the table.
      */
      overflow: hidden;

      text-overflow: clip;

      line-height: 1.35;

      box-sizing: border-box;
    }


    .dynamic-data-table tbody td:last-child {
      border-right: none !important;
    }


    /* =========================================================
       HIGHLIGHTED ROW
    ========================================================= */

    .dynamic-row-highlight {
      background: #fff1f2 !important;
    }

    .dynamic-row-highlight:hover {
      background: #ffe4e7 !important;
    }


    /* =========================================================
       ACTION BUTTONS
    ========================================================= */

    .dynamic-action-btn {
      width: 34px;
      height: 34px;

      padding: 0;
      margin: 0;

      border: none;

      border-radius: 9px;

      display: inline-flex;

      align-items: center;
      justify-content: center;

      cursor: pointer;

      transition:
        transform 0.18s ease,
        box-shadow 0.18s ease;
    }


    .dynamic-action-btn:hover {
      transform: translateY(-2px);
    }


    .dynamic-edit-btn {
      background: #e3f2fd;
    }


    .dynamic-edit-btn:hover {
      box-shadow:
        0 5px 12px rgba(25,118,210,0.25);
    }


    .dynamic-delete-btn {
      background: #ffebee;
    }


    .dynamic-delete-btn:hover {
      box-shadow:
        0 5px 12px rgba(211,47,47,0.25);
    }


    .dynamic-proceed-btn {
      background: #e8f5e9;
    }


    .dynamic-proceed-btn:hover {
      box-shadow:
        0 5px 12px rgba(46,125,50,0.25);
    }


    /* =========================================================
       NO DATA
    ========================================================= */

    .dynamic-no-data {
      padding: 35px 15px !important;

      text-align: center !important;

      color: #78909c !important;

      font-size: 14px !important;

      font-weight: 500;

      background: #fafcff !important;

      white-space: normal !important;
    }


    /* =========================================================
       FOOTER
    ========================================================= */

    .dynamic-table-footer {
      background: #f8fafc;

      border-top:
        1px solid #e1e6ef;
    }


    .dynamic-pagination-cell {
      padding: 12px 15px !important;

      text-align: center !important;

      white-space: normal !important;
    }


    .dynamic-total-cell {
      padding: 9px 15px !important;

      text-align: center !important;

      color: #1565c0 !important;

      background:
        linear-gradient(
          180deg,
          #f8fbff,
          #eef5fd
        ) !important;

      border-top:
        1px solid #e1e6ef !important;

      font-size: 13px !important;

      font-weight: 700 !important;

      white-space: normal !important;
    }


    /* =========================================================
       TABLET
    ========================================================= */

    @media (max-width: 768px) {

      .dynamic-table-wrapper {
        width: 100%;
        max-width: 100%;
        min-width: 0;

        margin: 8px 0 15px 0;

        border-radius: 12px;
      }


      /*
        IMPORTANT:
        No 760px minimum width.
      */

      .dynamic-data-table {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;

        table-layout: fixed !important;
      }


      .dynamic-table-header th {
        padding: 9px 5px !important;

        font-size: 10px !important;

        line-height: 1.2;

        white-space: normal !important;

        overflow-wrap: anywhere !important;

        word-break: break-word !important;
      }


      .dynamic-data-table tbody td {
        padding: 8px 5px !important;

        font-size: 11px !important;

        line-height: 1.3;

        white-space: normal !important;

        overflow-wrap: anywhere !important;

        word-break: break-word !important;
      }


      .dynamic-action-btn {
        width: 30px;
        height: 30px;
      }


      .dynamic-action-btn svg {
        font-size: 16px !important;
      }
    }


    /* =========================================================
       MOBILE
    ========================================================= */

    @media (max-width: 576px) {

      .dynamic-table-wrapper {
        width: 100%;
        max-width: 100%;
        min-width: 0;

        margin: 6px 0 12px 0;

        border-radius: 10px;

        box-shadow:
          0 4px 16px rgba(0,68,145,0.10);
      }


      .dynamic-table-scroll {
        width: 100%;
        max-width: 100%;
        min-width: 0;

        overflow-x: hidden;
        overflow-y: visible;
      }


      /*
        NO 700px MIN WIDTH.
        Table is exactly screen/container width.
      */

      .dynamic-data-table {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;

        table-layout: fixed !important;
      }


      .dynamic-table-header th {
        padding: 8px 4px !important;

        font-size: 9px !important;

        line-height: 1.2;

        white-space: normal !important;

        overflow-wrap: anywhere !important;

        word-break: break-word !important;
      }


      .dynamic-data-table tbody td {
        padding: 7px 4px !important;

        font-size: 9px !important;

        line-height: 1.3;

        white-space: normal !important;

        overflow-wrap: anywhere !important;

        word-break: break-word !important;
      }


      .dynamic-action-btn {
        width: 27px;
        height: 27px;

        border-radius: 7px;
      }


      .dynamic-action-btn svg {
        font-size: 14px !important;
      }


      .dynamic-pagination-cell {
        padding: 8px 2px !important;
      }


      .dynamic-total-cell {
        padding: 8px !important;

        font-size: 11px !important;
      }
    }


    /* =========================================================
       VERY SMALL MOBILE
    ========================================================= */

    @media (max-width: 400px) {

      .dynamic-table-header th {
        padding: 7px 3px !important;

        font-size: 8px !important;
      }


      .dynamic-data-table tbody td {
        padding: 6px 3px !important;

        font-size: 8px !important;
      }


      .dynamic-action-btn {
        width: 25px;
        height: 25px;
      }


      .dynamic-action-btn svg {
        font-size: 13px !important;
      }
    }
  `}
      </style>

      {/* =========================================================
          MAIN TABLE
      ========================================================== */}

      <div className="dynamic-table-wrapper">
        {/* Horizontal scrolling is limited to table only */}
        <div className="dynamic-table-scroll">
          <table className="dynamic-data-table" id="tbl">
            {/* =====================================================
                TABLE HEADER
            ====================================================== */}
            <colgroup>
              {columns.map((_, index) => (
                <col key={`data-col-${index}`} />
              ))}

              {onEditClick && (
                <col
                  style={{
                    width: "55px",
                  }}
                />
              )}

              {onDeleteClick && (
                <col
                  style={{
                    width: "60px",
                  }}
                />
              )}

              {showProceed && (
                <col
                  style={{
                    width: "65px",
                  }}
                />
              )}
            </colgroup>

            <thead>
              <tr className="dynamic-table-header">
                {columnNames.map((name, index) => (
                  <th key={index} scope="col">
                    {name}
                  </th>
                ))}

                {onEditClick && (
                  <th
                    scope="col"
                    style={{
                      width: "70px",
                      minWidth: "70px",
                      textAlign: "center",
                    }}
                  >
                    Edit
                  </th>
                )}

                {onDeleteClick && (
                  <th
                    scope="col"
                    style={{
                      width: "75px",
                      minWidth: "75px",
                      textAlign: "center",
                    }}
                  >
                    Delete
                  </th>
                )}

                {showProceed && (
                  <th
                    scope="col"
                    style={{
                      width: "85px",
                      minWidth: "85px",
                      textAlign: "center",
                    }}
                  >
                    Proceed
                  </th>
                )}
              </tr>
            </thead>

            {/* =====================================================
                TABLE BODY
            ====================================================== */}

            <tbody>
              {data && data.length > 0 ? (
                data.map((row, rowIndex) => {
                  const highlighted = isHighlighted(row);

                  return (
                    <tr
                      key={row.id ?? rowIndex}
                      title={row.title || ""}
                      className={highlighted ? "dynamic-row-highlight" : ""}
                    >
                      {/* ===============================
                          NORMAL COLUMNS
                      ================================ */}

                      {columns.map((column, colIndex) => {
                        const cellValue = row[column];

                        const isPendingDays = column
                          .toLowerCase()
                          .includes("pending days");

                        return (
                          <td
                            key={colIndex}
                            style={{
                              textAlign: isPendingDays ? "center" : "left",
                              width: `${100 / columns.length}%`,
                              maxWidth: `${100 / columns.length}%`,
                              overflow: "hidden",
                            }}
                          >
                            <div className="dynamic-cell-content">
                              {formatValue(column, cellValue)}
                            </div>
                          </td>
                        );
                      })}

                      {/* ===============================
                          EDIT
                      ================================ */}

                      {onEditClick && (
                        <td
                          style={{
                            textAlign: "center",
                          }}
                        >
                          <button
                            type="button"
                            id={`edit-${rowIndex}`}
                            title="Edit Entry"
                            className="
                              dynamic-action-btn
                              dynamic-edit-btn
                            "
                            onClick={(e) => {
                              e.stopPropagation();
                              onEditClick(row);
                            }}
                          >
                            <EditIcon
                              sx={{
                                color: "#1976d2",
                                fontSize: 18,
                              }}
                            />
                          </button>
                        </td>
                      )}

                      {/* ===============================
                          DELETE
                      ================================ */}

                      {onDeleteClick && (
                        <td
                          style={{
                            textAlign: "center",
                          }}
                        >
                          <button
                            type="button"
                            id={`delete-${rowIndex}`}
                            title="Delete Data"
                            className="
                              dynamic-action-btn
                              dynamic-delete-btn
                            "
                            onClick={(e) => {
                              e.stopPropagation();
                              onDeleteClick(row);
                            }}
                          >
                            <DeleteIcon
                              sx={{
                                color: "#d32f2f",
                                fontSize: 18,
                              }}
                            />
                          </button>
                        </td>
                      )}

                      {/* ===============================
                          PROCEED
                      ================================ */}

                      {showProceed && (
                        <td
                          style={{
                            textAlign: "center",
                          }}
                        >
                          <button
                            type="button"
                            id={`proceed-${rowIndex}`}
                            title="Proceed for Entry"
                            className="
                              dynamic-action-btn
                              dynamic-proceed-btn
                            "
                            onClick={(e) => {
                              e.stopPropagation();

                              if (onRowClick) {
                                onRowClick(row);
                              }
                            }}
                          >
                            <DoneOutlineIcon
                              sx={{
                                color: "#2e7d32",
                                fontSize: 18,
                              }}
                            />
                          </button>
                        </td>
                      )}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={totalColumns} className="dynamic-no-data">
                    No Data Available
                  </td>
                </tr>
              )}
            </tbody>

            {/* =====================================================
                FOOTER
            ====================================================== */}

            <tfoot className="dynamic-table-footer">
              <tr>
                <td colSpan={totalColumns} className="dynamic-pagination-cell">
                  <CustomPagination
                    itemsCount={totalRows}
                    itemsPerPage={pageSize}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    alwaysShown={true}
                    onClick={getData}
                  />
                </td>
              </tr>

              <tr>
                <td colSpan={totalColumns} className="dynamic-total-cell">
                  Total {totalRows} Data
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </>
  );
};

ListDynamicTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,

  columnNames: PropTypes.arrayOf(PropTypes.string).isRequired,

  data: PropTypes.arrayOf(PropTypes.object).isRequired,

  totalRows: PropTypes.number.isRequired,

  pageSize: PropTypes.number.isRequired,

  currentPage: PropTypes.number.isRequired,

  setCurrentPage: PropTypes.func.isRequired,

  onRowClick: PropTypes.func,

  getData: PropTypes.func,

  onEditClick: PropTypes.func,

  onDeleteClick: PropTypes.func,

  showProceed: PropTypes.bool,

  colorConditionColumn: PropTypes.string,

  colorConditionValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

export default ListDynamicTable;
